import React from 'react';
import { formattedAddress } from '#helper';

const optionCompanyKeys = [
  'firstName',
  'lastName',
  'companyName'
];

export const renderCompanyOption = excludeKey => (props, option) => {
  const { key, ...otherProps } = props;
  let optionInfo = optionCompanyKeys.reduce((a, c) => {
    if (c !== excludeKey && option?.details?.[c]) {
      a.push(option.details[c]);
    }
    return a;
  }, []).join(', ');
  if (optionInfo.length) {
    optionInfo += ';';
  }
  if (option?.details?.address) {
    optionInfo += ` ${formattedAddress(option.details.address)}`;
  }

  return (
    <div key={key} {...otherProps} style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', paddingTop: 8, paddingBottom: 8 }}>
      <span>
        {option.description}
      </span>
      <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.875rem' }}>
        {optionInfo}
      </span>
    </div>
  );
};
